import { IconButton } from '@ksyos/design-system';
import type { EpisodeCategory } from '@common/enums';
import type { ProcessStartWizardItem } from '@common/interfaces/processStartWizard';
import { translateKey } from '@frontend/translate';
import { NewProcessButton } from './NewProcessButton';
import { ProcessStartWizardButtonRowLayout } from './ProcessStartWizardButtonRowLayout';

interface IEpisodeCategoryButtonsProps {
    episodeCategories: ProcessStartWizardItem[];
    onClick: (name: any) => void;
    onClose: () => void;
    selectedEpisodeCategory?: EpisodeCategory;
    showCloseButton?: boolean;
}

export function EpisodeCategoryButtons(props: IEpisodeCategoryButtonsProps) {
    const { episodeCategories, onClick, onClose, selectedEpisodeCategory, showCloseButton } = props;

    return (
        <ProcessStartWizardButtonRowLayout
            action={
                showCloseButton ? (
                    <IconButton
                        icon="close"
                        labelText="Close"
                        onClick={onClose}
                        size="small"
                        variant="filled"
                    />
                ) : undefined
            }
        >
            {episodeCategories.map((item) => {
                return (
                    <NewProcessButton
                        automation={`processFlowService-${item.episodeCategory}`}
                        data={{ name: item.episodeCategory }}
                        key={item.episodeCategory}
                        name={translateKey(`episodeCategoryEnum.${item.episodeCategory}`)}
                        onClick={onClick}
                        previousSelection={selectedEpisodeCategory}
                    />
                );
            })}
        </ProcessStartWizardButtonRowLayout>
    );
}
